import React from 'react';
import { Link } from 'react-router-dom';

/**
 * 「參考另一筆資料」的連結——申請單 ↔ engagement ↔ 正式記錄 ↔ 另一張申請單，
 * 一律**另開新頁**。
 *
 * 為什麼：看單據時點到別的單據多半只是要對照一下（這張 FS 連的案子長怎樣、
 * 這筆 QC 是哪張 QCR 核准的），同頁跳走就得再按返回、表單裡還會把填到一半的
 * 內容丟掉。跨單據的參考在整站都用這一支，規則只有這一處。
 *
 * 不是這一支的：列表 → 詳情、返回列表、送出後跳到自己那張單、「下一步去填
 * ○○」——那些是流程本身的導航，繼續用 `Link` / `navigate` 同頁走。
 *
 * 用法與 `Link` 相同（`to`、`className`、`onClick`、`title`…都原樣傳下去）。
 */
const RefLink = ({ children, ...props }) => (
  <Link target="_blank" rel="noreferrer" {...props}>
    {children}
  </Link>
);

export default RefLink;
